import { render, staticRenderFns } from "./AutomacaoVariavelPicker.vue?vue&type=template&id=7387641a"
import script from "./AutomacaoVariavelPicker.vue?vue&type=script&lang=js"
export * from "./AutomacaoVariavelPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports